






import { GPSLocation } from '@/types/entity';
import { MapUtils } from '@/util/mapUtils';
import { Component, Vue } from 'vue-property-decorator';
// tslint:disable-next-line: no-var-requires
const googleMapStyle = require('../config/googleMapStyle.json');
// tslint:disable-next-line: no-var-requires
const carIcon = require('../assets/images/ambulance-icon2.png');
declare var google: any;
@Component({
    props: {
        route: Object,
        liveTracking: {
            type: Boolean,
            default: false,
        },
        location: Object,
        transportersLocation: {
            type: Array,
        },
        interpretersLocation: {
            type: Array,
        },
        routePolyline: [],
        dropoffAddressCoordinates: {
            type: Object,
        },
        pickupAddressCoordinates: {
            type: Object,
        },
        patientPickedUp: {
            type: Boolean,
            default: false,
        },
    },
})
export default class GoogleMap extends Vue {

    private marker = {} as any;
    private map = {} as any;
    private positionX: GPSLocation | undefined = undefined;
    private positionY: GPSLocation | undefined = undefined;
    private deltaLat = 0;
    private deltaLng = 0;
    private numDeltas = 500;
    private i = 0;
    private rotation = 0;
    private polyline: any = null;
    public mounted() {
        this.initMap();
    }
    public async updateLocation(location: GPSLocation) {
        if (!this.positionX) {
            this.positionX = this.$props.location;
            this.positionY = location;
        } else {
            this.positionX = this.positionY;
            this.positionY = location;
        }
        if (this.positionX && this.positionY) {
            const rotation = this.getBearing(this.positionX, this.positionY);
            if (rotation !== 0) {
                this.rotation = rotation;
            }
            this.updateMarkerIcon();
            this.i = 0;
            const path = await this.getDirectionsPath(this.positionX, this.positionY);
            if (path) {
                this.moveMarker(path);
            }
        }
    }

    private async getDirectionsPath(start: GPSLocation, end: GPSLocation): Promise<any | null> {
        return new Promise((resolve, reject) => {
            const directionsService = new google.maps.DirectionsService();
            const origin = new google.maps.LatLng(start.latitude, start.longitude);
            const destination = new google.maps.LatLng(end.latitude, end.longitude);
            const request = {
                origin,
                destination,
                travelMode: google.maps.TravelMode.DRIVING,
            };
            directionsService.route(request, (response: any, status: any) => {
                if (status === 'OK') {
                    const path = response.routes[0].overview_path.map((point: any) =>
                        new google.maps.LatLng(point.lat(), point.lng()));
                    resolve(path);
                } else {
                    console.error('Directions request failed due to ' + status);
                    resolve(null);
                }
            });
        });
    }


    private moveMarker(path: any) {
        if (this.positionX && this.positionY && this.map && this.marker) {
            if (this.i < path.length - 1) {
                const newPosition = path[this.i];
                this.marker.setPosition(newPosition);
                this.map.setCenter(newPosition);
                this.i++;
                const interval = 40;
                setTimeout(() => requestAnimationFrame(() => this.moveMarker(path)), interval);
            }
        }
    }

    private async initMap() {
        if (this.$props.routePolyline && this.$props.routePolyline.length > 0) {
            const icons = {
                start: new google.maps.MarkerImage(
                    require(`../assets/images/ambulance-icon.png`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(10, 10),
                ),
                end: new google.maps.MarkerImage(
                    require(`../assets/images/hospital-icon.png`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(22, 32),
                ),
            };
            const directionsRenderer = new google.maps.DirectionsRenderer({
                suppressMarkers: true,
                polylineOptions: {
                    strokeColor: '#11439c',
                },
            });
            const map = new google.maps.Map(this.$refs.map, {
                styles: googleMapStyle,
                zoom: 22,
            });
            directionsRenderer.setMap(map);
            const routePolyline = new google.maps.Polyline({
                path: this.$props.routePolyline,
                geodesic: true,
                strokeColor: '#000000',
                strokeOpacity: 1.0,
                strokeWeight: 2,
                icons: [
                    {
                        icon: {
                            path: 'M 0,-1 0,1',
                            strokeOpacity: 1,
                            scale: 4,
                        },
                        offset: '0',
                        repeat: '0px',
                    },
                ],
            });
            const firstElement = this.$props.routePolyline[0] as any;
            const lastElement = this.$props.routePolyline[this.$props.routePolyline.length - 1] as any;
            const bounds = new google.maps.LatLngBounds();
            bounds.extend(new google.maps.LatLng(firstElement.lat, firstElement.lng));
            bounds.extend(new google.maps.LatLng(lastElement.lat, lastElement.lng));
            map.fitBounds(bounds);
            const startPoint = this.$props.routePolyline[0];
            const endpoint = this.$props.routePolyline[this.$props.routePolyline.length - 1];
            const marker1 = new google.maps.Marker({
                position: startPoint,
                map,
                icon: icons.start,
            });
            const marker2 = new google.maps.Marker({
                position: endpoint,
                map,
                icon: icons.end,
            });
            routePolyline.setMap(map);
        } else if (this.$props.liveTracking) {
            const destinationLatLng = new google.maps.LatLng(this.$props.dropoffAddressCoordinates);
            const pickupAddressCoordinates = new google.maps.LatLng(this.$props.pickupAddressCoordinates);
            this.map = new google.maps.Map(this.$refs.map, {
                center: new google.maps.LatLng(this.$props.location.latitude, this.$props.location.longitude),
                styles: googleMapStyle,
                zoom: 24,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });
            // const bounds = new google.maps.LatLngBounds();
            // bounds.extend(new google.maps.LatLng(this.$props.location.latitude, this.$props.location.longitude));
            // this.map.fitBounds(bounds);
            this.marker = new google.maps.Marker({
                position: new google.maps.LatLng(
                    this.$props.location.latitude,
                    this.$props.location.longitude,
                ),
                map: this.map,
                title: 'Driver Location',
                icon: {
                    url: carIcon,
                    scaledSize: new google.maps.Size(40, 40),
                    anchor: new google.maps.Point(20, 20),
                    rotation: this.rotation,
                    size: {
                        height: 25,
                        width: 25,
                    },
                },
            });
            const directionsService = new google.maps.DirectionsService();
            const directionsRenderer = new google.maps.DirectionsRenderer({
                suppressMarkers: true,
                polylineOptions: {
                    strokeColor: 'black',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                },
            });

            directionsRenderer.setMap(this.map);

            const originLatLng = new google.maps.LatLng(this.$props.location.latitude, this.$props.location.longitude);
            let request = {};
            if (!this.$props.patientPickedUp) {
                request = {
                    origin: originLatLng,
                    destination: pickupAddressCoordinates,
                    travelMode: google.maps.TravelMode.DRIVING,
                };
            } else {
                request = {
                    origin: pickupAddressCoordinates,
                    destination: destinationLatLng,
                    travelMode: google.maps.TravelMode.DRIVING,
                };
            }
            directionsService.route(request, (response: any, status: any) => {
                if (status === 'OK') {
                    directionsRenderer.setDirections(response);
                } else {
                    console.error('Directions request failed due to ' + status);
                }
            });
            const pickupCods = this.$props.pickupAddressCoordinates;
            const dropOffCods = this.$props.dropoffAddressCoordinates;
            const pickupAddress = await MapUtils.getAddressByCoordinates(pickupCods.lat, pickupCods.lng);
            const dropOffAddress = await MapUtils.getAddressByCoordinates(dropOffCods.lat, dropOffCods.lng);
            const marker1 = new google.maps.Marker({
                position: pickupAddressCoordinates,
                map: this.map,
                title: 'Pickup Address',
                icon: {
                    url: 'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="green" viewBox="0 0 384 512"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>', // or other symbol path
                    scaledSize: new google.maps.Size(30, 30),
                    anchor: new google.maps.Point(15, 15),
                },
            });
            const infoWindow1 = new google.maps.InfoWindow({
                content: `<div class='PickupAddress'><strong>${marker1.title}</strong><br>${this.trimAddress(pickupAddress.fullAddress)}</div>`,
            });

            infoWindow1.open(this.map, marker1); // Open InfoWindow by default

            const marker2 = new google.maps.Marker({
                position: destinationLatLng,
                map: this.map,
                title: 'Drop-off Address',
                icon: {
                    url: 'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="red" viewBox="0 0 384 512"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>', // or other symbol path
                    scaledSize: new google.maps.Size(30, 30),
                    anchor: new google.maps.Point(15, 15),
                },
            });
            const infoWindow2 = new google.maps.InfoWindow({
                content: `<div class='Drop-offAddress'><strong>${marker2.title}</strong><br>${this.trimAddress(dropOffAddress.fullAddress)}</div>`,
            });

            infoWindow2.open(this.map, marker2);
        } else if (this.$props.transportersLocation) {
            this.map = new google.maps.Map(this.$refs.map, {
                center: new google.maps.LatLng(this.$props.transportersLocation[0].latitude,
                    this.$props.transportersLocation[0].longitude),
                styles: googleMapStyle,
                zoom: 3,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });
            for (const location of this.$props.transportersLocation) {
                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(location.latitude, location.longitude),
                    map: this.map,
                    title: 'Transporters Location',
                });
            }
        } else if (this.$props.interpretersLocation) {
            this.map = new google.maps.Map(this.$refs.map, {
                center: new google.maps.LatLng(this.$props.interpretersLocation[0].latitude,
                    this.$props.interpretersLocation[0].longitude),
                styles: googleMapStyle,
                zoom: 3,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });
            for (const location of this.$props.interpretersLocation) {
                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(location.latitude, location.longitude),
                    map: this.map,
                    title: 'Interpreter Location',
                });
            }
        } else {
            const directionsRenderer = new google.maps.DirectionsRenderer({
                suppressMarkers: true,
                polylineOptions: {
                    strokeColor: '#11439c',
                },
            });
            const directionsService = new google.maps.DirectionsService();
            const map = new google.maps.Map(this.$refs.map, {
                styles: googleMapStyle,
                zoom: 24,
            });
            directionsRenderer.setMap(map);
            const bounds = new google.maps.LatLngBounds();
            bounds.extend(new google.maps.LatLng(this.$props.route.origin.lat, this.$props.route.origin.lng));
            bounds.extend(new google.maps.LatLng(this.$props.route.destination.lat, this.$props.route.destination.lng));
            map.fitBounds(bounds);
            const selectedMode = 'DRIVING';
            const icons = {
                start: new google.maps.MarkerImage(
                    // URL
                    require(`../assets/images/${this.$props.route.origin.icon}`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(10, 10),
                ),
                end: new google.maps.MarkerImage(
                    // URL
                    require(`../assets/images/${this.$props.route.destination.icon}`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(22, 32),
                ),
                stop: new google.maps.MarkerImage(
                    // URL
                    require(`../assets/images/${this.$props.route.stop.icon}`),
                    new google.maps.Size(50, 50),
                    new google.maps.Point(0, 0),
                    new google.maps.Point(22, 32),
                ),
            };
            const waypoints: any = [];
            if (this.$props.route.additionalStops && this.$props.route.additionalStops.length > 0) {
                this.$props.route.additionalStops.forEach((stop: any) => {
                    waypoints.push({
                        location: new google.maps.LatLng(stop.address.latitude, stop.address.longitude),
                        stopover: true,
                    });
                });
            }
            directionsService.route(
                {
                    destination: this.$props.route.destination,
                    origin: this.$props.route.origin,
                    travelMode: google.maps.TravelMode[selectedMode],
                    waypoints,
                },
                async (response: any, status: any) => {
                    if (status === 'OK') {
                        directionsRenderer.setDirections(response);
                        if (response.routes[0].legs.length > 1) {
                            const legA = response.routes[0].legs[0];
                            const legB = response.routes[0].legs[1];
                            const marker1 = new google.maps.Marker({
                                position: legA.start_location,
                                map,
                                icon: icons.start,
                                title: legA.start_address,
                            });
                            const marker2 = new google.maps.Marker({
                                position: legA.end_location,
                                map,
                                icon: icons.stop,
                                title: legA.end_address,
                            });
                            const marker3 = new google.maps.Marker({
                                position: legB.end_location,
                                map,
                                icon: icons.end,
                                title: legB.end_address,
                            });
                        } else {
                            const leg = response.routes[0].legs[0];
                            // Marker 1
                            const marker1 = new google.maps.Marker({
                                position: this.$props.route.origin,
                                map,
                                title: 'Pickup Address',
                                icon: {
                                    url: 'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="green" viewBox="0 0 384 512"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>', // or other symbol path
                                    scaledSize: new google.maps.Size(30, 30),
                                    anchor: new google.maps.Point(15, 15),
                                },
                            });

                            const infoWindow1 = new google.maps.InfoWindow({
                                content: `<div class='PickupAddress'><strong>${marker1.title}</strong><br>${this.trimAddress(leg.start_address)}</div>`,
                            });

                            infoWindow1.open(map, marker1);
                            // Marker 2
                            const marker2 = new google.maps.Marker({
                                position: leg.end_location,
                                map,
                                icon: {
                                    url: 'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="green" viewBox="0 0 384 512"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>', // or other symbol path
                                    scaledSize: new google.maps.Size(30, 30),
                                    anchor: new google.maps.Point(15, 15),
                                },
                                title: 'Dropoff Address',
                            });

                            const infoWindow2 = new google.maps.InfoWindow({
                                content: `<div class='Drop-offAddress'><strong>${marker2.title}</strong><br>${this.trimAddress(leg.end_address)}</div>`,
                            });

                            infoWindow2.open(map, marker2);
                        }
                    } else {
                        window.alert('Directions request failed due to ' + status);
                    }
                },
            );
        }
    }

    private getBearing(start: GPSLocation, end: GPSLocation): number {
        const toRadians = (angle: number) => angle * (Math.PI / 180);
        const lat1 = toRadians(start.latitude);
        const lon1 = toRadians(start.longitude);
        const lat2 = toRadians(end.latitude);
        const lon2 = toRadians(end.longitude);

        const y = Math.sin(lon2 - lon1) * Math.cos(lat2);
        const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);

        let bearing = Math.atan2(y, x);
        bearing = bearing * (180 / Math.PI);
        bearing = (bearing + 360) % 360;

        return bearing;
    }

    private getRotatedImageUrl(rotation: number): Promise<string> {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = carIcon;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                if (context) {
                    context.translate(canvas.width / 2, canvas.height / 2);
                    context.rotate((rotation * Math.PI) / 180);
                    context.drawImage(img, -canvas.width / 2, -canvas.height / 2);

                    const rotatedImageUrl = canvas.toDataURL('image/png');
                    resolve(rotatedImageUrl);
                }
            };
        });
    }

    private async updateMarkerIcon() {
        const rotatedImageUrl = await this.getRotatedImageUrl(this.rotation);
        this.marker.setIcon({
            url: rotatedImageUrl,
            scaledSize: new google.maps.Size(70, 70),
            anchor: new google.maps.Point(35, 35),
        });
    }

    private createPolyline() {
        if (this.positionX && this.positionY) {
            const directionsService = new google.maps.DirectionsService();
            const originLatLng = new google.maps.LatLng(this.positionX.latitude, this.positionX.longitude);
            const destinationLatLng = new google.maps.LatLng(this.positionY.latitude, this.positionY.longitude);
            const request = {
                origin: originLatLng,
                destination: destinationLatLng,
                travelMode: google.maps.TravelMode.DRIVING,
            };
            directionsService.route(request, (response: any, status: any) => {
                if (status === 'OK') {
                    const path = response.routes[0].overview_path;
                    if (this.polyline) {
                        this.polyline.setMap(null);
                    }
                    this.polyline = new google.maps.Polyline({
                        path,
                        geodesic: true,
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                    });
                } else {
                    console.error('Directions request failed due to ' + status);
                }
            });
        }
    }

    private getPositionAtDistance(path: any, distance: number): any {
        let currentDistance = 0;
        for (let i = 0; i < path.getLength() - 1; i++) {
            const segmentStart = path.getAt(i);
            const segmentEnd = path.getAt(i + 1);
            const segmentLength = google.maps.geometry.spherical.computeDistanceBetween(segmentStart, segmentEnd);
            if (currentDistance + segmentLength >= distance) {
                const heading = google.maps.geometry.spherical.computeHeading(segmentStart, segmentEnd);
                const overage = distance - currentDistance;
                return google.maps.geometry.spherical.computeOffset(segmentStart, overage, heading);
            }
            currentDistance += segmentLength;
        }
        return path.getAt(path.getLength() - 1);
    }

    private trimAddress(address: string) {
        let updatedAddress = '';
        if (address.length > 50) {
            updatedAddress = address.substring(0, 50) + '...';
        } else {
            updatedAddress = address;
        }
        return updatedAddress;
    }
}
